import React, { useEffect, useMemo } from 'react';

// MUI
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';

function CustomCard(props) {

    const { content, action, padding, scrollToBottom, mapError, overFlow = true, ...rest } = props


    // Media query screen size
    const theme = useTheme();
    const xsDown = useMediaQuery(theme.breakpoints.down('sm'));
    const smDown = useMediaQuery(theme.breakpoints.down('md'));
    const mdDown = useMediaQuery(theme.breakpoints.down('lg'));
    const lgDown = useMediaQuery(theme.breakpoints.down('xl'));
    const xlDown = useMediaQuery(theme.breakpoints.down('xl'));

    // Calculate spacing 
    const hideScrollBar = useMemo(() => {

        // Values
        const values = { xs: true, sm: true, md: true, lg: false, xl: false }

        if (xsDown) {
            return values.xs
        }
        else {
            if (smDown) {
                return values.sm
            }
            else {
                if (mdDown) {
                    return values.md
                }
                else {
                    if (lgDown) {
                        return values.lg
                    }
                    else {
                        if (xlDown) {
                            return values.xl
                        }
                        else {
                            return values.xl
                        }
                    }
                }
            }
        }

    }, [xsDown, smDown, mdDown, lgDown, xlDown]);

    // On mount
    useEffect(() => {

        return () => {
            // Clean up
        }
    }, [])

    return (
        <Box
            display='flex'
            flexDirection='column'
            flexWrap='nowrap'
            width={1}
            style={{ minHeight: "555px", maxHeight: 'fit-content' }}
            height='auto'
            boxShadow={1}
            bgcolor="background.paper"
            {...rest}
        >
            {/* Content */}
            {
                content &&
                <Box width={1} p={padding} flex='1 0 0' style={{ overflow: overFlow ? 'inherit' : 'auto' }} overflow={{ xs: 'auto', md: 'auto' }} className='hide-native-scrollbar'>
                    {content}
                </Box>
            }

            {/* Actions */}
            {
                action &&
                <Box width={1} p={padding} className="hide-native-scrollbar">
                    {action}
                </Box>
            }
            {
                props.children
            }
        </Box>
    )
}

// Export
export default CustomCard
